module.exports = __webpack_public_path__ + "static/media/LogicLever5_1_3.ab17462b.png";